import { render, staticRenderFns } from "./ImagePopup.vue?vue&type=template&id=74fc041d&scoped=true"
import script from "./ImagePopup.vue?vue&type=script&lang=js"
export * from "./ImagePopup.vue?vue&type=script&lang=js"
import style0 from "./ImagePopup.vue?vue&type=style&index=0&id=74fc041d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fc041d",
  null
  
)

export default component.exports